import React from 'react'

import { NavLink as ReactRouterNavLink } from 'react-router-dom'
import { Divider, Drawer, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Dashboard as DashboardIcon } from '@mui/icons-material'

import UserLinks from '../UserLinks'
import LogoLink from './components/LogoLink'

import { primaryColor, primaryColorOpacity } from '@edge/spark/ui-mui'
import SpacerToolbar from '../SpacerToolbar'
import {
    useActiveDashboardIdStore,
    setActiveDashboardId as handleClickSwitchDashboard,
    useAllDashboardsQuery,
} from '@edge/spark/io-dashboards'
import { useDrawerOpenStore } from '../DesktopDrawer/drawerOpen.store'

const ListContainer = styled('div')`
    display: flex;
    margin-top: 10px;
    flex-direction: column;
    transition: 0.4s ease all;
`
const ListItem = styled('div')`
    display: flex;
    padding: 10px 30px 10px 10px;
    flex-direction: row;
    color: inherit;
    align-items: center;
    justify-content: space-between;

    :hover {
        transition: 0.1s ease all;
        color: ${primaryColor};
        background-color: #f5f5f5;
    }
`
const StyledText = styled(Typography)`
    display: flex;
    justify-content: flex-start;
    padding-left: 20px;
    width: 100%;
    color: inherit;
`

const MobileDrawer = (): React.ReactElement => {
    const activeDashboardId = useActiveDashboardIdStore((state) => state.id)
    const { open: gloablDrawerOpenState, setOpen } = useDrawerOpenStore()
    const normalizedDashboards = useAllDashboardsQuery()

    const closeDrawer = (): void => setOpen(false)

    return (
        <div>
            <Drawer
                anchor="top"
                onClose={closeDrawer}
                open={gloablDrawerOpenState}
                PaperProps={{ sx: { width: '100%', height: '100%' } }}
                sx={{ zIndex: 101 }}
            >
                <SpacerToolbar />
                <LogoLink />
                <Divider />
                <ListContainer>
                    {normalizedDashboards.map((d) => (
                        <ReactRouterNavLink
                            key={`mobile-${d.id}`}
                            to="/"
                            style={{ textDecoration: 'none', color: 'gray' }}
                            activeStyle={{ color: primaryColor, backgroundColor: primaryColorOpacity }}
                            isActive={(match) => !!match?.isExact && d.id === activeDashboardId}
                            onClick={() => {
                                handleClickSwitchDashboard(d.id)
                                closeDrawer()
                            }}
                        >
                            <ListItem>
                                <DashboardIcon sx={{ paddingLeft: '14px' }} />
                                <StyledText variant="body2">{d.name}</StyledText>
                            </ListItem>
                        </ReactRouterNavLink>
                    ))}
                    <UserLinks onClick={closeDrawer} />
                </ListContainer>
            </Drawer>
        </div>
    )
}

export default MobileDrawer
